<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
  <div class="cards-holder">
    <div class="card card2 mRight" #chartcontainer>
      <div class="c-portlet__header">
        <div class="o-stack__cell">
          <h5 class="creative-charts-header card-title">{{sectiontitle}}</h5>
          <span class="datatable-icon" *ngIf="hasData">
            <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank"
                *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
                <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </div>
      <div class="performance-graph-area">
        <select (change)="updateCampaign($event.target.value)" *ngIf="hasData">
          <option *ngFor="let campaign of displayData; let index = index" [value]="index" [selected]="campaign.name == setDisplayProperties.name" class="performance-graph-campaign">{{campaign.name}}</option>
        </select>
        <div class="card3 preroll-creative-v3-carousel-cntr creative-performance-stats display-creative-container">
          <!-- <app-loader [showLoader]=showLoad></app-loader> -->
          <div class="analytics-portlet-Img100p display-preroll-carousel-height" *ngIf="hasData">
            <div class="c-portlet o-block u-width-100p _u-width-100p widget-grid u-shadow-mini u-bg-primary u-color-white-900">
              <div class="c-portlet__content u-pt-small">
                <div class="o-stack o-stack center preroll-creative-img" id="videoDisplayblock">
                  <div class="video-width">
                    <div class="align-controls">
                      <div class="ShowControls" [hidden]="setDisplayProperties.mp4==''">  
                        <video class="" (click)="controlsOptions()" id="preRollvideo" autoplay #videoName [src]="setDisplayProperties.mp4">
                          <source type="video/mp4" /> Your browser does not support HTML5 video.
                        </video>
                        <div class="showIconsControls" *ngIf="displayData && displayData.length > 0">
                          <span class="playVideo" (click)="playclickEvent()">
                            <img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
                          </span>
                          <span class="playVideo" (click)="pauseclickEvent()">
                            <img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
                          </span>
                        </div>
                      </div>
                      <div class="volumecontrols">
                        <span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
                          <!--<i class="volumecontrols fa fa-volume-up"></i>-->
                          <span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
                          <img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
                        </span>
                        <span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
                          <!--<i class="volumecontrols fa fa-volume-off"></i>-->
                          <span class="VolumeControlHoverClass">UNMUTE</span>
                          <img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
                        </span>
                      </div>
                    </div>
                    <div>
                      <div class="preRoll-creative-stats creative-stats">
                        <div class="metrics-div">
                          <div class="stats preRoll-creative-header-content">{{setDisplayProperties.impressions|formatNumber}}</div>
                          <div class="stats-label preRoll-creative-views ">IMPRESSIONS</div>
                        </div>
                        <div class="metrics-div">
                          <div class="stats preRoll-creative-header-content">{{setDisplayProperties.percent_value_100 | formatNumber}}</div>
                          <div class="stats-label preRoll-creative-views ">COMPLETIONS</div>
                        </div>
                        <div class="metrics-div">
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.completion_rate | formatNumber}}%</span>
                          <span class="stats-label preRoll-creative-views ">COMPLETION RATE</span>
                        </div>
                        <!-- <div class="metrics-div">
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.clicks|formatNumber}}</span>
                          <span class="stats-label preRoll-creative-views ">CLICKS</span>
                        </div>
                        <div class="metrics-div">
                          <span class="stats preRoll-creative-header-content">{{setDisplayProperties.click_rate}}%</span>
                          <span class="stats-label preRoll-creative-views ">CLICK RATE</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="r4-mRight">
                    <div class="mRight creative-performance-stats detail-colors">
                      <!-- <app-loader [showLoader]=showLoad></app-loader> -->
                      <div class="preRoll-creative-completion-stats-container">
                        <div class="preRoll-creative-completion-stats-scroll-div" *ngIf="hasData && overallCompletionData">
                          <div class="preRoll-creative-completion-stats creative_text_mask" id="percent0" (click)="circleVideoClickEvent(0)">
                            <div class="progressbar">
                              <div class="primary-color-bg progressbar-primary-color-bg"></div>
                            </div>
                            <div class="preRoll-creative-views par-title-font add-color">
                              <span class="par-title">Started</span><span class="par-val primary-color">100% |
                                {{setDisplayProperties.impressions|formatNumber}} Views</span></div>
                          </div>
                          <div class="preRoll-creative-completion-stats creative_text_mask" id="percent25" (click)="circleVideoClickEvent(25)">
                            <div class="progressbar">
                              <div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.quarter)"></div>
                            </div>
                            <div class="preRoll-creative-views  par-title-font add-color">
                              <span class="par-title">25% Completed</span><span class="par-val primary-color">{{setDisplayProperties.percent_rate_25}}%
                                | {{setDisplayProperties.percent_value_25|formatNumber}} Views</span></div>
                          </div>
                          <div class="preRoll-creative-completion-stats creative_text_mask" id="percent50" (click)="circleVideoClickEvent(50)">
                            <div class="progressbar">
                              <div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
                            </div>
                            <div class="preRoll-creative-views par-title-font add-color">
                              <span class="par-title">50% Completed</span><span class="par-val primary-color">{{setDisplayProperties.percent_rate_50}}%
                                | {{setDisplayProperties.percent_value_50|formatNumber}} Views</span></div>
                          </div>
                          <div class="preRoll-creative-completion-stats creative_text_mask" id="percent75" (click)="circleVideoClickEvent(75)">
                            <div class="progressbar">
                              <div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.threeQuarters)"></div>
                            </div>
                            <div class="preRoll-creative-views par-title-font add-color">
                              <span class="par-title">75% Completed</span><span class="par-val primary-color">{{setDisplayProperties.percent_rate_75}}%
                                | {{setDisplayProperties.percent_value_75|formatNumber}} Views</span></div>
                          </div>
                          <div class="preRoll-creative-completion-stats creative_text_mask" id="percent100" (click)="circleVideoClickEvent(100)">
                            <div class="progressbar">
                              <div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.completed)"></div>
                            </div>
                            <div class="preRoll-creative-views par-title-font add-color">
                              <span class="par-title">100% Completed</span><span class="par-val primary-color">{{setDisplayProperties.percent_rate_100}}%
                                | {{setDisplayProperties.percent_value_100|formatNumber}} Views</span></div>
                          </div>
                        </div>
                        <div class="no-data-container" *ngIf="!hasData">
                          <div class="map-no-data">No Data to Display</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="no-data-container" *ngIf="!hasData">
              <app-loader [showLoader]=showLoad *ngIf="showLoad"></app-loader>
            <div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="card card1 mLeft lift-right right-card">
      <app-loader [showLoader]=showLoad></app-loader>
          <div class="c-portlet__header r4-c-portlet__header network-title">
              <div class="o-stack__cell">
                <h5>Featured Networks</h5>
              </div>
            </div>      
            <div *ngIf="hasFeaturedData" class="preRoll-creative-completion-stats-scroll-div y-scroll-area">
              <div class="preRoll-creative-completion-stats network-featured-list" *ngFor="let network of featuredNetworks">
                <div class="network-icon-container">
                  <img src="{{network.logoPath}}" width="60" />
                </div>
                <div class="network-details-container">
                  <div class="progressbar">
                    <div class="primary-color-bg-right-gradient" [style.width.%]="network.completionRate"></div>
                  </div>
                  <div class="preRoll-creative-views par-title-font add-color par-val primary-color">{{network.completionRate}}% Completion Rate</div>
                </div>
              </div>
            </div>
      <div  *ngIf="!hasFeaturedData">
          <div class="map-no-data">No Data to Display</div>
        </div>
  </div>
</div>
